<template>
  <div>
    <v-card class="mt-3">
      <v-list-item @click="onClickItem">
        <v-row dense no-gutters class="mt-3 mb-3">
          <v-col cols="12" sm="6" md="3">
            {{ nome }}
            <div class="caption">
              {{ cnpj | cnpj }}
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="5" :class="smallClass">
            {{ cotacao.municipioColeta.nome }} ({{ cotacao.municipioColeta.estado.sigla }})
            <v-icon>mdi-arrow-right</v-icon>
            {{ cotacao.municipioEntrega.nome }} ({{ cotacao.municipioEntrega.estado.sigla }})
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="`${smClass} ${smallClass}`">
            {{ cotacao.valorMercadoria | currency }}
            <div class="caption">
              Valor da mercadoria
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="3" :class="`d-flex align-center ${smallClass}`">
            <v-icon class="mr-1">mdi-weight</v-icon>
            {{ cotacao.pesoTotal }} kg
          </v-col>
          <v-col cols="12" sm="6" md="5" :class="`d-flex align-center ${smallClass}`">
            <px-painel-cotacoes-item-volumes v-if="cotacao.volumes.length"
                                             :cotacao="cotacao">
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  <v-icon class="mr-1">mdi-package-variant</v-icon>
                  {{ cotacao.volumes.length }} conjunto(s)
                </span>
              </template>
            </px-painel-cotacoes-item-volumes>
            <span v-else>
              <v-icon class="mr-1">mdi-package-variant</v-icon>
              Sem volumes
            </span>
          </v-col>
          <v-col cols="12" sm="6" md="4" :class="`mt-3 ${smallClass}`">
            {{ cotacao.tipoMercadoria }}
            <div class="caption">
              Tipo de mercadoria
            </div>
          </v-col>
        </v-row>
        <v-list-item-action>
          <v-btn icon @click="onClickItem">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-card>
    <px-premium-banner-dialog ref="premiumDialog"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PainelCotacoesItemVolumes from './PainelCotacoesItemVolumes.vue';

export default {
  props: {
    cotacao: Object,
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['isPremium']),
    smallClass() {
      if (this.$vuetify.breakpoint.xs) {
        return 'mt-4';
      }
      return '';
    },
    smClass() {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'mt-3';
      }
      return '';
    },
    nome() {
      if (this.cotacao.company) {
        return this.cotacao.company.pessoa.nome;
      }
      return '***************';
    },
    cnpj() {
      if (this.cotacao.company) {
        return this.cotacao.company.pessoa.cnpj;
      }
      return '***************';
    },
  },
  methods: {
    onClickItem() {
      if (!this.isPremium) {
        this.$refs.premiumDialog.open();
        return;
      }
      this.$router.push({
        name: 'main.cotacoes.detalhes',
        params: { id: this.cotacao.id },
        query: { origin: 'PAINEL' },
      });
    },
  },
  components: {
    pxPainelCotacoesItemVolumes: PainelCotacoesItemVolumes,
  },
};
</script>
